import get from 'lodash/get';

const selectModal = (state, modal) => get(state, `modals.${modal}`, false);

export default selectModal;
